import { useUserContextSelector } from '@/redux';
import { useCallback } from 'react';
import type { PersonalizationSummaryFormValue } from './DownloadPersonalizationSummaryPdfModal';
import {
  getPersonalizationSummaryPdfSettings,
  savePersonalizationSummaryPdfSettings,
} from './personalizationSummaryPdfSettingsStorage';

export function usePersonalizationSummaryPdfSettingsState() {
  const userId = useUserContextSelector((x) => x.id);
  const defaultSettings = getPersonalizationSummaryPdfSettings(userId);
  const saveSettings = useCallback(
    (values: PersonalizationSummaryFormValue) => {
      savePersonalizationSummaryPdfSettings(userId, values);
    },
    [userId],
  );

  return { defaultSettings, saveSettings };
}
